import loadable from '@loadable/component';

export const PathwayPage = loadable(/* #__LOADABLE__ */ () => import('./PathwayPage'));
